import { toast } from 'react-toastify';
import useDesignerStore from './designerStore';

const MediaTile = ({ media, src, onSelect, onDelete }) => {
  const addObject = useDesignerStore(state => state.addObject);

  // 🚀 HOVER PREFETCH (does NOT change your add flow)
  const handleMouseEnter = () => {
    if (!src || media.type !== 'image') return;
    const img = new Image();
    img.src = src;
  };

  const handleAddImage = async () => {
    try {
      const response = await fetch(src, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache'
      });

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      const img = new window.Image();

      img.onload = () => {
        let width = img.width;
        let height = img.height;

        const maxDimension = 400;

        if (width > maxDimension || height > maxDimension) {
          const scale = Math.min(maxDimension / width, maxDimension / height);
          width *= scale;
          height *= scale;
        }

        const newImageObj = {
          id: `img-${Date.now()}`,
          type: 'image',
          x: 100,
          y: 100,
          width,
          height,
          draggable: true,
          opacity: 1,
          stroke: '#000000',
          strokeWidth: 1,
          dash: [],
          rotation: 0,
          brightness: 0,
          contrast: 0,
          grayscale: 0,
          sepia: 0,

          // 🔥 unified media system
          src: objectUrl,     // for Konva
          originalSrc: src    // for persistence
        };

        addObject(newImageObj);
      };

      img.src = objectUrl;

      toast.info('Image loading to canvas…');

    } catch (error) {
      console.error('Error loading image:', error);
      toast.error('Failed to load image');
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();

    if (!onDelete) return;

    toast.warning(
      <div>
        <div style={{ marginBottom: 8 }}>Delete this media?</div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            className="btn-danger"
            onClick={() => {
              toast.dismiss();
              onDelete(media);
            }}
          >
            Delete
          </button>

          <button
            className="btn-secondary"
            onClick={() => toast.dismiss()}
          >
            Cancel
          </button>
        </div>
      </div>,
      { autoClose: false }
    );
  };

  return (
    <div
      className="media-tile"
      onMouseEnter={handleMouseEnter}
      onClick={() => onSelect && onSelect(media)}
      style={{
        cursor: 'pointer',
        contentVisibility: 'auto',
        containIntrinsicSize: '120px 120px'
      }}
    >
      <div className="media-tile-preview">
        {media.type === 'image' ? (
          <img
            src={src}
            loading="lazy"
            decoding="async"
            alt=""
          />
        ) : (
          <video src={src} preload="metadata" />
        )}
      </div>

      <div className="media-tile-actions">
        <button
          className="btn-save"
          onClick={(e) => {
            e.stopPropagation();
            handleAddImage();
          }}
        >
          Add
        </button>

        <button
          className="btn-delete"
          onClick={handleDelete}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default MediaTile;
